import { QuestionProps } from "../models/question"

export const setQuestionStatus = (q: QuestionProps) => {
    let status = !!q.answer ? 'completed' : ''
    status = q.questionType === 'multiChoice' && !q.answer?.length ? '' : status
    status = q.attachmentsRequired && !q.answerAttachments?.length ? '' : status
    return {
        ...q,
        status: status,
    }
}